<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="description" content="Nimi is an open-source, local-first home for your AI. Talk, write, research, and create with AI that gets to know you—and stays with you across apps and worlds." />
    <meta name="keywords" content="Nimi, personal AI, local AI, AI conversations, AI creation, AI characters, AI worlds, open source AI" />
    <meta name="theme-color" content="#ffffff" />
    <meta property="og:type" content="website" />
    <meta property="og:title" content="Nimi | Your AI, Your way." />
    <meta property="og:description" content="Nimi is an open-source, local-first home for your AI. Talk, write, research, and create with AI that gets to know you—and stays with you across apps and worlds." />
    <meta property="og:image" content="https://nimi.ai/og-image.png" />
    <meta property="og:url" content="https://nimi.ai" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Nimi | Your AI, Your way." />
    <meta name="twitter:description" content="Nimi is an open-source, local-first home for your AI. Talk, write, research, and create with AI that gets to know you—and stays with you across apps and worlds." />
    <meta name="twitter:image" content="https://nimi.ai/og-image.png" />
    <link rel="canonical" href="https://nimi.ai" />
    <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
    <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
    <link rel="icon" href="/favicon.ico" sizes="any" />
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link href="https://fonts.googleapis.com/css2?family=Geist:wght@500;600;700&family=IBM+Plex+Sans:wght@400;500;600;700&family=Inter:wght@500;600;700&family=JetBrains+Mono:wght@400;600&family=Noto+Sans+SC:wght@400;500;600;700&family=Sora:wght@500;600;700&family=Space+Grotesk:wght@500;600;700&family=ZCOOL+QingKe+HuangYou&display=swap" rel="stylesheet" />
    <title>Nimi | Your AI, Your way.</title>
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "Nimi",
      "url": "https://nimi.ai",
      "logo": "https://nimi.ai/logo.svg",
      "description": "Nimi is an open-source, local-first home for your AI. Talk, write, research, and create with AI that gets to know you—and stays with you across apps and worlds.",
      "applicationCategory": "LifestyleApplication",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD"
      },
      "author": {
        "@type": "Organization",
        "name": "Nimi Network Limited",
        "url": "https://nimi.ai"
      }
    }
    </script>
    <script>
      document.documentElement.dataset.nimiScheme = 'light';
      document.documentElement.dataset.nimiAccent = 'nimi-accent';
      document.documentElement.classList.add('nimi-theme-accent--nimi-accent');
    </script>
  </head>
  <body>
    <div id="root"></div>
    <script type="module" src="/src/main.tsx"></script>
  </body>
</html>
